import { useSettings } from 'Settings'
import { v4 } from 'uuid'

const Switch = ({ root, state }) => {
	return (
		<line
			x1={root[0]}
			y1={root[1]}
			x2={state[0]}
			y2={state[1]}
			stroke="black"
		/>
	)
}

const lts = {
	root : [325, 540],
	states : {
		false : [355, 526],
		true : [355, 540]
	}
}

const vaux_rel = {
	'sts' : [-20, -10],
	'ldo' : [-20, -1],
	'gnd' : [-20, 13],
	'disabled' : [-20, 6],
}

const vaux = {
	0: {
		root : [695, 220],
		state : {}
	},
	1: {
		root : [695, 260],
		state : {}
	},
	2: {
		root : [695, 300],
		state : {}
	},
}

const gnd_rel = {
	true: [-20, 13],
	false: [-20, -10]
}

const gnd = {
	0 : {
		root : [695, 340],
		state : {}
	},
	1 : {
		root : [695, 380],
		state : {}
	},
	2 : {
		root : [695, 420],
		state : {}
	},
}

const Switches = () => {
	const [settings] = useSettings();

	[0, 1, 2].forEach((i) => {
		const root = vaux[i]['root']
		vaux[i]['state']['sts'] = [root[0] + vaux_rel['sts'][0], root[1] + vaux_rel['sts'][1]]
		vaux[i]['state']['ldo'] = [root[0] + vaux_rel['ldo'][0], root[1] + vaux_rel['ldo'][1]]
		vaux[i]['state']['gnd'] = [root[0] + vaux_rel['gnd'][0], root[1] + vaux_rel['gnd'][1]]
		vaux[i]['state']['disabled'] = [root[0] + vaux_rel['disabled'][0], root[1] + vaux_rel['disabled'][1]]
	});

	[0, 1, 2].forEach((i) => {
		const root = gnd[i]['root']
		gnd[i]['state'][true] = [root[0] + gnd_rel[true][0], root[1] + gnd_rel[true][1]]
		gnd[i]['state'][false] = [root[0] + gnd_rel[false][0], root[1] + gnd_rel[false][1]]
	});

	const vaux_sw_state = (i) => {
		if (settings['vaux'][i]['enable'].value) {
			const cct = settings['vaux'][i]['constantly connect to'].value
			if (cct === 0) {
				return 'sts'
			} else if (cct === 1) {
				return 'ldo'
			} else {
				return 'gnd'
			}
		} else {
			return 'disabled'
		}
	}

	return (
		<>
			<Switch
				root={lts.root}
				state={lts.states[settings['supervisory']['always connect'].value]}
			/>
			{
			[0, 1, 2].map((i) =>
				<Switch
					key={ v4() }
					root={vaux[i].root}
					state={vaux[i]['state'][vaux_sw_state(i)]}
				/>)
			}
			{
			[0, 1, 2].map((i) =>
				<Switch
					key={ v4() }
					root={gnd[i].root}
					state={gnd[i]['state'][settings['vaux gnd'][i]['enable'].value]}
				/>)
			}
			<Switch
				root={[275, 170]}
				state={[295, 180]}
			/>
			<Switch
				root={[675, 140]}
				state={[695, 150]}
			/>
		</>
	)
}

export default Switches
